import { checkMeetingStatus } from "./js/Meetings";

document.addEventListener("DOMContentLoaded", () => {
  if(window.meetingsData){

    // simple promise timer
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    // run the ui refresh update every 30 seconds (30000ms)
    async function runMeetingChecker() {
        while (true) {
            checkMeetingStatus(window.meetingsData, '#live-meetings-container');
            await sleep(30000).catch(err => {
                console.log(`Meeting Checker interrupted: ${err.message}`);
                return Promise.reject(err); // break loop
            });
        }
    }

    // refresh the page every 5 mins (300000ms) in case backend updated with meetings
    async function runReloader() {
        while (true) {
            await sleep(300000).catch(err => {
                console.log(`Reloader interrupted: ${err.message}`);
                return Promise.reject(err); // break loop
            });
            location.reload(); // refresh page
        }
    }

    // Build a clock
    function updateClock() {
        const now = new Date();
        let hours = now.getHours();
        let minutes = now.getMinutes();
        let seconds = now.getSeconds();
        hours = String(hours).padStart(2, '0');
        minutes = String(minutes).padStart(2, '0');
        seconds = String(seconds).padStart(2, '0');
        const timeString = `${hours}:${minutes}:${seconds}`;
        document.getElementById('clock').textContent = timeString;
    }
    setInterval(updateClock, 1000);

    // Run both tasks concurrently without blocking the main execution thread
    runMeetingChecker();
    runReloader();
    updateClock();

  } else {
    console.log(`Meetings JSON is not available.`)
  }
});
